<!-- T11 — Toast stack rendered top-right above all routes -->
<div class="toast-stack" aria-live="polite" aria-atomic="false">
  <div
    *ngFor="let n of notifications; trackBy: trackById"
    class="toast"
    [class.toast--success]="n.type === Type.SUCCESS"
    [class.toast--error]="n.type === Type.ERROR"
    [class.toast--warning]="n.type === Type.WARNING"
    [class.toast--info]="n.type === Type.INFO"
    role="alert"
  >
    <i *ngIf="n.icon" class="toast__icon" [ngClass]="n.icon"></i>
    <div class="toast__body">
      <div *ngIf="n.title" class="toast__title">{{ n.title }}</div>
      <div class="toast__message">{{ n.message }}</div>
      <button
        *ngIf="n.action"
        type="button"
        class="toast__action"
        (click)="invokeAction(n)"
      >
        {{ n.action.label }}
      </button>
    </div>
    <button
      *ngIf="n.dismissible !== false"
      type="button"
      class="toast__close"
      aria-label="Fermer"
      (click)="dismiss(n.id)"
    >
      <i class="fas fa-times"></i>
    </button>
  </div>
</div>
